// extracted by mini-css-extract-plugin
export default {"starPoint":"Satisfaction_starPoint__EN68Y","starTrack":"Satisfaction_starTrack__tRelS","starFill":"Satisfaction_starFill__NDUwC"};